// Sticky ATC lišta na detailu produktu (issue #15, m05-product.md §20).
//
// Nenativní prvek: klonuje se jen vzhled — cena (qty × cena, sdílený `productPrice.js`)
// a tlačítko, jehož klik pouští NATIVNÍ `.add-to-cart-button` uvnitř formu
// (`realBtn.click()`), takže košík dál obsluhuje `shoptet.cartShared.addToCart`.
//
// Lišta se ukáže, až pás CTA hlavní karty odscrolluje nad viewport. Spodní navigace se na
// `body.type-product` nestaví vůbec (bottomNav.js), takže se obě lišty nemůžou potkat;
// `body.has-atc` přesto necháváme jako hák pro případ, že by se to změnilo.
//
// Idempotentní (`html.bs-atc-ready`).

import { icon } from './icon.js';
import { createPriceWatch, formatPrice } from './productPrice.js';
import { createSaleEnd, saleEndFor } from './saleEnd.js';
import { shoptetData } from '../shoptet-hooks.js';
import L from '../locale/cs/stickyAtc.js';

const LABEL_CART = L.addToCart;
const LABEL_REGION = L.region;

export function initStickyAtc() {
  const root = document.documentElement;
  if (root.classList.contains('bs-atc-ready')) return;
  if (!document.body.classList.contains('type-product')) return;

  const form = document.querySelector('#product-detail-form');
  if (!form) return;
  const realBtn = form.querySelector('.add-to-cart-button');
  const anchor = form.querySelector('.bs-buy__row') || realBtn;
  if (!realBtn || !anchor) return;

  const bar = document.createElement('div');
  bar.className = 'bs-atc';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', LABEL_REGION);
  bar.setAttribute('aria-hidden', 'true');

  const inner = document.createElement('div');
  inner.className = 'bs-atc__inner';

  const priceBox = document.createElement('div');
  priceBox.className = 'bs-atc__price';
  const total = document.createElement('strong');
  total.className = 'bs-atc__total';
  const standard = document.createElement('span');
  standard.className = 'bs-atc__standard';
  priceBox.appendChild(total);
  priceBox.appendChild(standard);
  // konec akční ceny pod přeškrtnutou cenou (plní se z indexu, viditelný jen při slevě)
  const sale = document.createElement('span');
  sale.className = 'bs-atc__sale-slot';
  sale.hidden = true;
  priceBox.appendChild(sale);

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'bs-atc__btn';
  btn.tabIndex = -1;
  btn.appendChild(icon('cart'));
  const label = document.createElement('span');
  label.textContent = LABEL_CART;
  btn.appendChild(label);
  btn.addEventListener('click', function () {
    realBtn.click(); // nativní handler formu = jediná cesta do košíku
  });

  inner.appendChild(priceBox);
  inner.appendChild(btn);
  bar.appendChild(inner);
  document.body.appendChild(bar);

  // příslušenství z upsellu (productDetail.js) hlásí součet eventem — lišta ho
  // přičítá k qty × cena, ať ukazuje totéž co CTA v kartě; množstevní pásmo
  // (#228) hlásí ratio stejnou cestou, jinak by lišta od 2. pásma výš lhala
  let extras = 0;
  let qdRatio = 1;
  const watch = createPriceWatch(form);
  function render(state) {
    const sum = isFinite(state.total) ? Math.round(state.total * qdRatio * 100) / 100 + extras : NaN;
    total.textContent = isFinite(sum) ? formatPrice(sum, state.currency) : state.text;
    standard.textContent = state.standardText;
    standard.hidden = !state.standardText;
    // konec akce jen při reálné slevě na stránce (přeškrtnutá cena)
    sale.hidden = !(state.standardText && sale.firstChild);
  }
  watch.subscribe(render);
  document.addEventListener('bs:pd-qd', function (e) {
    const next = e.detail && isFinite(e.detail.ratio) ? e.detail.ratio : 1;
    if (next === qdRatio) return;
    qdRatio = next;
    render(watch.state);
  });
  const product = shoptetData('product');
  if (product && product.code) {
    saleEndFor(product.code).then(function (toDate) {
      if (!toDate || sale.firstChild) return;
      const el = createSaleEnd(toDate, { className: 'bs-atc__sale' });
      if (!el) return;
      sale.appendChild(el);
      sale.hidden = !standard.textContent;
      sale.addEventListener('bs:sale-end-expired', function () {
        sale.hidden = true;
      });
    });
  }
  document.addEventListener('bs:pd-extras', function (e) {
    extras = (e.detail && e.detail.sum) || 0;
    render(watch.state);
  });

  function show(on) {
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    btn.tabIndex = on ? 0 : -1;
    document.body.classList.toggle('has-atc', on);
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // jen když buy-box odjel NAHORU — před ním lištu nepotřebujeme
          show(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        });
      },
      { threshold: 0 }
    ).observe(anchor);
  }

  root.classList.add('bs-atc-ready');
}
